import moment from 'moment'
import React, { useEffect, useState } from 'react'

import { Button, DatepickerNew, Popover, useIsClient } from '../../module'
import SelectedDate from './SelectedDate'
import styles from './_date-range.module.scss'
import { c } from '../../translations/LibraryTranslationService'

/**
 * @deprecated Please use DatePicker instead
 **/
const DateRange = ({
  startDate,
  singleDate,
  endDate,
  selected,
  specifiedDay,
  resetDate,
  callout,
  showCalendar,
  customClickText,
  hideCustomDateSearch,
  placement,
  isOutsideRangeHandler,
  showAllDates = false,
}) => {
  const [state, setState] = useState({
      start_date: null,
      end_date: null,
    }),
    { start_date, end_date } = state,
    isClient = useIsClient()
  useEffect(() => {
    if (!startDate && !endDate) {
      setState({ start_date: null, end_date: null })
    }
  }, [startDate, endDate])

  const dateRangeCallout = (closeMenu) => {
    if (singleDate) {
      callout(start_date)
      closeMenu()
    } else if (start_date !== null && end_date !== null) {
      callout(start_date, end_date)
      closeMenu()
    }
  }

  const datepickerUpdate = (start, end, closeMenu) => {
    const startDate = moment(start),
      endDate = end ? moment(end) : null
    setState((prevState) => ({
      ...prevState,
      start_date: startDate,
      end_date: endDate,
    }))
    if (hideCustomDateSearch) {
      customDateRangeCallout(startDate, endDate, closeMenu)
    }
  }

  const customDateRangeCallout = (startDate, endDate, closeMenu) => {
    if (startDate !== null && endDate !== null) {
      callout(startDate, endDate)
      closeMenu?.()
    }
  }

  const singleDatepickerUpdate = (start, closeMenu) => {
    const date = moment(start)
    setState((prevState) => ({
      ...prevState,
      start_date: date,
    }))
    callout(date)
    closeMenu()
  }

  const cancelSearch = (closeMenu, reset) => {
    setState({
      start_date: null,
      end_date: null,
    })
    closeMenu()
    if (reset) {
      resetDate?.()
    }
  }

  let useable_start_date = start_date?.isValid() ? start_date : startDate,
    useable_end_date = end_date || endDate

  return (
    <div
      className={`${styles.dateRangeContainer} ${
        customClickText
          ? (
              useable_start_date && !singleDate
                ? useable_end_date
                : useable_start_date
            )
            ? styles.darkBorder
            : styles.lightBorder
          : ''
      }`}
    >
      <Popover
        popoverContent={({ setVisible }) => {
          const closeTippy = () => setVisible(false)
          return (
            <div className={styles.dateRangeTippy}>
              {singleDate ? (
                <DatepickerNew
                  startDate={moment(useable_start_date)}
                  startDateId='datepicker-date'
                  onDateChange={(startDate) =>
                    singleDatepickerUpdate(startDate, closeTippy)
                  }
                  specifiedDay={specifiedDay || moment()}
                  isSingle
                  focused
                  customClass='right'
                  isOutsideRangeHandler={isOutsideRangeHandler}
                  showAllDates={showAllDates}
                />
              ) : (
                <DatepickerNew
                  startDate={
                    useable_start_date ? moment(useable_start_date) : null
                  }
                  endDate={useable_end_date ? moment(useable_end_date) : null}
                  startDateId='datepicker-start-date'
                  endDateId='datepicker-end-date'
                  onDatesChange={datepickerUpdate}
                  specifiedDay={specifiedDay || moment()}
                  closeMenu={closeTippy}
                  resetDate={() => cancelSearch(closeTippy, true)}
                  reset
                  customClass='left'
                  isOutsideRangeHandler={isOutsideRangeHandler}
                  showAllDates={showAllDates}
                />
              )}
              {!hideCustomDateSearch && !singleDate && (
                <div className={styles.datepickerSearchButtons}>
                  <Button
                    onClick={() => {
                      cancelSearch(closeTippy)
                    }}
                  >
                    {c('cancel')}
                  </Button>
                  <Button
                    styleType={'primary-green'}
                    onClick={() => {
                      dateRangeCallout(closeTippy)
                    }}
                  >
                    {c('search')}
                  </Button>
                </div>
              )}
            </div>
          )
        }}
        position={placement || 'bottom-end'}
        {...(isClient ? { appendTo: document.body } : {})}
      >
        {({ setVisible }) => (
          <div>
            <Button
              className={styles.buttonStyle}
              as='unstyled'
              onClick={() => setVisible(true)}
            >
              <div className={styles.selectedText}>
                {customClickText ? (
                  customClickText(
                    useable_start_date ? moment(useable_start_date) : null,
                    !singleDate
                      ? useable_end_date
                        ? moment(useable_end_date)
                        : null
                      : useable_start_date
                        ? moment(useable_start_date)
                        : null,
                  )
                ) : (
                  <SelectedDate
                    dateRangeSelected={selected}
                    startDate={
                      useable_start_date ? moment(useable_start_date) : null
                    }
                    endDate={
                      !singleDate
                        ? useable_end_date
                          ? moment(useable_end_date)
                          : null
                        : useable_start_date
                          ? moment(useable_start_date)
                          : null
                    }
                    singleDate={singleDate}
                    timeframe={!singleDate ? true : false}
                    showCalendar={showCalendar}
                  />
                )}
              </div>
            </Button>
          </div>
        )}
      </Popover>
    </div>
  )
}

export default DateRange
